import { Component, OnInit } from "@angular/core";
import { DataService } from "../services/data/data-service";
import { MailingService } from "../services/mailing/mailing-service";

@Component({
  selector: "app-content",
  templateUrl: "./content.component.html",
  styleUrls: ["./content.component.css", "bootstrap.min.css"],
})
export class ContentComponent implements OnInit {
  public dataSet: any = [];
  public country: string;
  public selection: string;
  public selection2: string;
  public newCases: number = 0;
  public newDeaths: number = 0;
  public totalCases: number = 0;
  public totalDeaths: number = 0;
  public totalRecovered: number = 0;
  public totalActiveCases: number = 0;

  public message: string;
  public email: string;

  public floor(x: number): number {
    return Math.floor(x);
  }

  public validateEmail(email: string) {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
  }

  public addEmail() {
    if (!this.validateEmail(this.email)) {
      this.message = "Your email address is not valid !";
    } else {
      //addingEmail
      this.mailingService.addEmail(this.email);
      this.message = "email " + this.email + " added successfully !";
      this.email = "";
    }
  }

  constructor(
    private service: DataService,
    private mailingService: MailingService
  ) {}

  ngOnInit(): void {
    this.service.getData().subscribe((v) => {
      for (let val in v) {
        if (v[val].country_name !== "") this.dataSet.push(v[val]);
        this.newCases +=
          v[val].new_cases.split(",").join("") === "N/A"
            ? 0
            : parseInt(v[val].new_cases.split(",").join(""));
        this.newDeaths +=
          v[val].new_deaths.split(",").join("") === "N/A"
            ? 0
            : parseInt(v[val].new_deaths.split(",").join(""));
        this.totalCases +=
          v[val].cases.split(",").join("") === "N/A"
            ? 0
            : parseInt(v[val].cases.split(",").join(""));
        this.totalDeaths +=
          v[val].deaths.split(",").join("") === "N/A"
            ? 0
            : parseInt(v[val].deaths.split(",").join(""));
        this.totalRecovered +=
          v[val].total_recovered.split(",").join("") === "N/A"
            ? 0
            : parseInt(v[val].total_recovered.split(",").join(""));
        this.totalActiveCases +=
          v[val].active_cases.split(",").join("") === "N/A"
            ? 0
            : parseInt(v[val].active_cases.split(",").join(""));
      }
    });
  }
}
